export enum RoutesEnum {
  AUTHENTICATION = 'authentication',
  HOME = 'home',
  USERS = 'users',
  SENSORS = 'sensors',
  BOXES = 'boxes',
  PATIENTS = 'patients',
  CLINICAL_REPORT = 'clinical-report',
  SETTINGS = 'settings',
  HEALTH_CENTERS = 'health-centers',
}
